import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiTokenRepository from "@/repository/apiTokenRepository";
import { apiQueryKeys } from "./keys";


export const useRefreshAPIToken = () => {
    const queryClient = useQueryClient();

    return useMutation<string, AxiosError, void>({
        mutationKey: ["api", "refresh"],
        mutationFn: async () => {
            try {
                const { data } = await apiTokenRepository.refresh();
                return data?.token ?? "";
            } catch (e) {
                throw e;
            }
        },
        retry: false,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: apiQueryKeys.read()
            });
        }
    });
};
